import { Command, PriceData } from '../interfaces';

export enum PRICE_SORT {
    LOW_HIGH = 'LOW_HIGH',
    HIGH_LOW = 'HIGH_LOW',
}

/**
 * Sort based on the price. I.e Lowest to highest or highest to lowest.
 * @param data a treatment
 * @returns PriceData[]
 */
export const priceSort = <T extends PriceData>(data: T[], keys: keyof typeof PRICE_SORT) => {
    let result: PriceData[] = [];
    if (keys === PRICE_SORT.LOW_HIGH) {
        result = data.sort((a, b) => a.priceFrom - b.priceFrom);
    }
    if (keys === PRICE_SORT.HIGH_LOW) {
        result = data.sort((a, b) => b.priceFrom - a.priceFrom);
    }
    return result;
};

export class PriceSortCommand implements Command {
    isAndFilter() {
        return undefined;
    }

    execute(data: PriceData[], keys: keyof typeof PRICE_SORT) {
        return priceSort(data, PRICE_SORT[keys]);
    }
}
